export default {
    cz: {
        machineId: {
            title: 'Informace o zařízení',
            label: 'ID stroje',
        },
        borrower: {
            title: 'Na koho byl stroj půjčený',
            label: 'Firma nebo jméno a příjmení',
        },
        contactPerson: {
            title: 'Kontaktní osoba, která hlásí škodu',
            name: 'Jméno a příjmení',
            phone: 'Telefon',
        },
        damageDate: {
            title: 'Kdy škoda vznikla',
            date: 'Datum',
            time: 'Čas',
        },
        damageEvent: {
            title: 'Jak škoda vznikla',
            label: 'Vyberte možnost',
            options: {
                prompt: 'Vyberte možnost',
                Work: 'Při práci se strojem',
                ThirdPerson: 'Třetí osobou nebo cizím předmětem',
                Vandalism: 'Vandalismem',
                NaturalElement: 'Vlivem přírodního živlu',
                Alienation: 'Odcizením',
                Other: 'Jiným způsobem',
            },
        },
        description: {
            label: 'Popis události',
        },
        file: {
            label: 'Fotodokumentace',
            title: 'Přiložte fotografie poškozeného stroje a jeho okolí v místě a času nehody',
        },
        gdpr: (
            <>
                Souhlasím se
                {' '}
                <a href="/obsah/o-nas/osobni-udaje">zpracováním osobních údajů</a>
            </>
        ),
        gdprError: 'Musíte souhlasit se zpracováním osobních údajů',
        button: 'Odeslat',
        success: 'Formulář byl úspěšně odeslaný.',
    },
    sk: {
        machineId: {
            title: 'Informácie o zariadení',
            label: 'ID stroja',
        },
        borrower: {
            title: 'Na koho bol stroj požičaný',
            label: 'Firma alebo meno a priezvisko',
        },
        contactPerson: {
            title: 'Kontaktná osoba, ktorá hlási škodu',
            name: 'Meno a priezvisko',
            phone: 'Telefón',
        },
        damageDate: {
            title: 'Kedy škoda vznikla',
            date: 'Dátum',
            time: 'Čas',
        },
        damageEvent: {
            title: 'Ako škoda vznikla',
            label: 'Vyberte možnosť',
            options: {
                prompt: 'Vyberte možnosť',
                Work: 'Pri práci so strojom',
                ThirdPerson: 'Tretou osobou alebo cudzím predmetom',
                Vandalism: 'Vandalizmom',
                NaturalElement: 'Vplyvom prírodného živlu',
                Alienation: 'Odcudzením',
                Other: 'Iným spôsobom',
            },
        },
        description: {
            label: 'Popis udalosti',
        },
        file: {
            label: 'Fotodokumentácia',
            title: 'Pripojte fotografie poškodeného stroja a jeho okolia v mieste a čase nehody',
        },
        gdpr: (
            <>
                Súhlasím s
                {' '}
                <a href="/obsah/o-nas/osobne-udaje">spracovaním osobných údajov</a>
            </>
        ),
        gdprError: 'Musíte súhlasiť so spracovaním osobných údajov',
        button: 'Odoslať',
        success: 'Formulár bol úspešne odoslaný.',
    },
}
